<template>
    <div class="driver-add">
        <HeaderNav
            header-title="添加司机"
            left-icon-name=""
            right-icon-name=""
        ></HeaderNav>
        <div class="main-wrapper">
            <p class="warning">
                注：务必输入司机和车辆信息，以免车辆无法入场
            </p>
            <div class="message-wrapper">
                <ul class="msg-wrapper">
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-1"></i><span class="msg-title">车牌号</span>
                            </van-col>
                            <van-col span="14">
                                <van-field v-model="formData.car_no" placeholder="请输入车牌号"></van-field>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-2"></i><span class="msg-title">司机姓名</span>
                            </van-col>
                            <van-col span="14">
                                <van-field v-model="formData.driver_name" placeholder="请输入司机姓名"></van-field>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-3"></i><span class="msg-title">联系电话</span>
                            </van-col>
                            <van-col span="14">
                                <van-field v-model="formData.driver_phone" placeholder="请输入联系电话"></van-field>
                            </van-col>
                        </van-row>
                    </li>
                </ul>
            </div>
        </div>
        <span class="submit-btn" @click="submitChange()">提交</span>
        <span class="return-btn" @click="handleBack"><i class="iconfont ">&#xe607;</i></span>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            formData: {},
            row: {},
            CheckedArr: [],
        };
    },
    watch: {
        formData() {
        },
    },
    created() {
        this.row = JSON.parse(this.$route.query.row);
        this.CheckedArr = JSON.parse(this.$route.query.CheckedArr);
    },
    methods: {
        handleBack() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'driverList', query: { row: JSON.stringify(this.row), CheckedArr: JSON.stringify(this.CheckedArr) } });
            this.$router.go(-1);
        },
        submitChange() {
            if (this.row.transport_type === 1) {
                this.formData.transport_id = this.row.transport_id;
            } else {
                this.formData.supplier_id = this.row.supplier_id;
            }
            this.$dialog.confirm({
                message: '确定要提交',
            }).then(() => {
                this.$toast.loading({
                    message: '请求中...',
                    forbidClick: false,
                    loadingType: 'spinner',
                });
                this.formData.car_no = this.formData.car_no.replace(/\s+/g, '');
                this.$axios
                    .post('/interfaceApi/procurement/truck/savetruck', this.formData)
                    .then(() => {
                        this.$toast.success({
                            message: '添加成功',
                            duration: 500,
                        });
                        setTimeout(() => {
                            this.$router.isBack = 1;
                            this.handleBack();
                        }, 1000);
                    })
                    .catch(error => {
                        this.$toast('message:' + error.ErrorCode.Message + '');
                    });
            }).catch(() => {
                // on cancel
            });

        },
    },
};
</script>

<style lang="stylus">
.driver-add
    padding-top 44rpx
    height calc(100% - 44rpx)
    background rgba(240,240,240,1)
    position relative
    .submit-btn
        position absolute
        top 15rpx
        right 15rpx
        color #fff
        font-size 14rpx
        z-index 999
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    .main-wrapper
        height 100%
        overflow-y auto
        overflow-x hidden
        .warning
            width 100%
            height 30rpx
            line-height 30rpx
            background rgba(254,229,229,1)
            color #E60000
            text-align center
            font-size 12rpx
        .message-wrapper
            background #ffffff
            .title
                height 45rpx
                line-height 45rpx
                color #3495FB
                font-size 18rpx
                padding-left 15px
                border-bottom 2rpx solid rgba(240,240,240,1)
                i
                    margin-right 15rpx
            .msg-wrapper
                .msg-item
                    height 45rpx
                    line-height 45rpx
                    border-bottom 2rpx solid rgba(240,240,240,1)
                    .msg-title
                        margin-left 15rpx
                        // padding-left 15rpx
                        display block
                        // width 100%
                        font-size 16rpx
                        &::after
                            content "*"
                            color #E60000
                    i
                        width: 16rpx
                        height 16rpx
                        background url(./../../assets/images/icons/icon_gy_9.png)
                        background-size 100% 100%
                        display inline-block
                        float left
                        margin 15rpx
                        &.title-2
                            background url(./../../assets/images/icons/icon_3.png)
                            background-size 100% 100%
                        &.title-3
                            background url(./../../assets/images/icons/icon_4.png)
                            background-size 100% 100%
                    .msg-content
                        display block
                        width 100%
                        text-align right
                        padding-right 15rpx
                        color #979EA7
                        font-size 14rpx
                    .van-cell
                        padding 0 15rpx 0 0
                    .van-field__control
                        text-align right
                        height 42rpx
                        line-height 24rpx
                        padding-top 8rpx

</style>